import React, { useContext, useRef, useState } from 'react'
import { DialogOverlay, TextField, DialogOverlayActions, DialogOverlayFooter, Button } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { PersonContext } from '../PersonContext'
import { deleteOtherInfo } from '../../../services/personService'
import useNotifications from '../../../hooks/useNotifications'

export default function OtherInfoDeleteDialog({ conclusionIds, ...opener }) {
  const { error } = useNotifications()
  const { currentPerson, fetchCurrentPerson } = useContext(PersonContext)
  const personId = currentPerson.id
  const [changeReason, setChangeReason] = useState()
  const { t } = useTranslation()
  const focusElementRef = useRef()

  const handleDelete = () => {
    deleteOtherInfo(personId, conclusionIds, changeReason)
      .then(() => {
        fetchCurrentPerson()
      })
      .catch((err) => {
        error(`Error deleting other info for a person: ${err.message || ''}`, err)
      })
  }

  return (
    <DialogOverlay {...opener} focusRef={focusElementRef} title={t('person.reference.confirmRemove', 'Confirm Remove')}>
      {t('person.other.deleteMessage', 'Are you sure you want to remove this information?')}
      <TextField
        ref={focusElementRef}
        id="Change Reason"
        label={t('reason', 'Reason')}
        value={changeReason}
        onChange={(event) => setChangeReason(event.target.value)}
      />

      <DialogOverlayFooter>
        <DialogOverlayActions>
          <Button emphasis="high" onClick={handleDelete}>
            {t('action.confirm', 'Confirm')}
          </Button>
          <Button emphasis="medium" onClick={opener.close}>
            {t('action.cancel', 'Cancel')}
          </Button>
        </DialogOverlayActions>
      </DialogOverlayFooter>
    </DialogOverlay>
  )
}
